module.exports = __webpack_public_path__ + "img/pro-lab2.f30b3a79.png";